interface AllCauseMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}

const AllCauseMenu: React.FC<AllCauseMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
    setIsFiltersOpen?.();
  };
  return (
    <ul>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={54}
            checked={!clear && displayValue === 54}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Total </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={55}
            checked={!clear && displayValue === 55}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Hospitalization{" "}
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={56}
            checked={!clear && displayValue === 56}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Emergency Room{" "}
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={57}
            checked={!clear && displayValue === 57}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Urgent Care</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={58}
            checked={!clear && displayValue === 58}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Outpatient</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={59}
            checked={!clear && displayValue === 59}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Pharmacy </span>
        </label>
      </li>
    </ul>
  );
};

export default AllCauseMenu;
